import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { formatInteger } from '../../_shared/ululeStats'
import { type Collection } from '../collections'
import { useStatsTracking } from '../tracking'
import styles from './PopularGrid.module.css'

/**
 * The live collections, as plain cards: cover, name, contributor count, and deliberately nothing
 * else. The ranked list this replaced read as a league table whose figures did not explain the
 * order, so the cards show one figure and order themselves by it.
 */
export function PopularGrid({ collections }: { collections: Collection[] }): React.ReactElement {
  const tracking = useStatsTracking()

  return (
    <div className={styles.grid}>
      {collections.map((collection, index) => (
        <a
          key={collection.url}
          className={styles.card}
          href={collection.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => tracking.projectClick('popular', index + 1)}
        >
          <span className={styles.card__cover} aria-hidden="true">
            {collection.imageUrl === undefined ? (
              <plume.glyphs.stroke.Media size={34} />
            ) : (
              <img className={styles.card__img} src={collection.imageUrl} alt="" loading="lazy" decoding="async" />
            )}
          </span>
          <span className={styles.card__body}>
            <span className={styles.card__name}>{collection.name}</span>
            <span className={styles.card__meta}>
              <strong>{formatInteger(collection.backersCount)}</strong>
              {` contributeur·ice${collection.backersCount > 1 ? 's' : ''}`}
            </span>
          </span>
        </a>
      ))}
    </div>
  )
}
